export const EXPERIENCE_COUNT = [
  {
    title: "Less than 1 year",
    count: 0,
  },
  {
    title: "1-2 years",
    count: 0,
  },
  {
    title: "3-5 years",
    count: 0,
  },
  {
    title: "6-10 years",
    count: 0,
  },
  {
    title: "More than 10 years",
    count: 0,
  },
  {
    title: "Others",
    count: 0,
  },
];

export const GIG_COUNT = [
  {
    title: "Contract",
    count: 155,
  },
  {
    title: "Permanent",
    count: 0,
  },
  {
    title: "Per Diem",
    count: 0,
  },
];
export const IT_JOB_TYPES = [
  {
    title: "Contract",
    count: 155,
  },
  {
    title: "Permanent",
    count: 0,
  },
];

export const HC_JOB_TYPES = [
 ...IT_JOB_TYPES,
  {
    title: "Per Diem",
    count: 0,
  },
];

export const YEARS_OF_EXP_OPTIONS = [
  { label: "0–2 yrs", value: "0_2" },
  { label: "3–5 yrs", value: "3_5" },
  { label: "6–10 yrs", value: "6_10" },
  { label: "10–20 yrs", value: "10_20" },
  { label: "20–50 yrs", value: "20_50" },
  { label: "50+ yrs", value: "50_100" },
];